export const PROGRAM_LOCAL_PERIOD_ERROR_MESSAGE =
  'Periode harus memiliki tanggal mulai dan selesai yang valid.'

type TProgramLocalPickerDate = {
  format: (template: string) => string
}

export type TSerializedProgramLocalPeriod = {
  startDate?: string
  endDate?: string
}

const DATE_FORMAT_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

const isPickerDate = (value: unknown): value is TProgramLocalPickerDate =>
  typeof value === 'object' &&
  value !== null &&
  'format' in value &&
  typeof value.format === 'function'

const toUtcStartOfDayISOString = (value: unknown) => {
  if (!isPickerDate(value)) {
    throw new Error(PROGRAM_LOCAL_PERIOD_ERROR_MESSAGE)
  }

  const formattedDate = value.format('YYYY-MM-DD')
  const dateParts = DATE_FORMAT_PATTERN.exec(formattedDate)

  if (!dateParts) {
    throw new Error(PROGRAM_LOCAL_PERIOD_ERROR_MESSAGE)
  }

  const [, yearValue, monthValue, dayValue] = dateParts
  const year = Number(yearValue)
  const month = Number(monthValue)
  const day = Number(dayValue)
  const utcDate = new Date(0)

  utcDate.setUTCHours(0, 0, 0, 0)
  utcDate.setUTCFullYear(year, month - 1, day)

  if (
    utcDate.getUTCFullYear() !== year ||
    utcDate.getUTCMonth() !== month - 1 ||
    utcDate.getUTCDate() !== day
  ) {
    throw new Error(PROGRAM_LOCAL_PERIOD_ERROR_MESSAGE)
  }

  return utcDate.toISOString()
}

export const serializeProgramLocalPeriod = (
  periode: unknown,
): TSerializedProgramLocalPeriod => {
  if (periode == null) {
    return { startDate: undefined, endDate: undefined }
  }

  if (!Array.isArray(periode) || periode.length !== 2) {
    throw new Error(PROGRAM_LOCAL_PERIOD_ERROR_MESSAGE)
  }

  const [startDate, endDate] = periode

  if (startDate == null && endDate == null) {
    return { startDate: undefined, endDate: undefined }
  }

  if (startDate == null || endDate == null) {
    throw new Error(PROGRAM_LOCAL_PERIOD_ERROR_MESSAGE)
  }

  return {
    startDate: toUtcStartOfDayISOString(startDate),
    endDate: toUtcStartOfDayISOString(endDate),
  }
}
